/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
import { useI18n } from 'vue-i18n';
import showformmodel from "../showformmodel/showformmodel.vue"
import AssignEproPopup from "../AssignEproPopup/AssignEproPopup.vue";
import customModal from "../customModal/customModal.vue";
import viewAlertDetailsPopup from '../viewAlertDetailsPopup/viewAlertDetailsPopup.vue';
import AlertStatusPopup from '../AlertStatusPopup/AlertStatusPopup.vue';
import viewAlertQueryPopup from '../ViewAlertQuery/viewAlertQueryPopup.vue';
import moment from "moment";
import { thresholdScott } from "d3";
export default {
  components: {
    showformmodel,
    customModal,
    AssignEproPopup,
    viewAlertDetailsPopup,
    AlertStatusPopup,
    viewAlertQueryPopup
  },
  name: "epro",
  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat") ? localStorage.getItem("timeformat") : "hh:mma";
    window.addEventListener("studyIdChanged", async (event) => {
      this.GetRecentFormData();
      this.getecrfformlist();
      this.getcomplaince();
      this.getcompleted();
      await this.getpatientlist();
      this.getrecentsubmissions();
      this.getActiveAlerts();
      this.getActiveAlertsCounts();
    });
    this.GetRecentFormData();
    this.getecrfformlist();
    this.getcomplaince();
    this.getcompleted();
    await this.getpatientlist();
    this.getrecentsubmissions();
    this.getActiveAlerts();
    this.getActiveAlertsCounts();
  },
  data() {
    return {
      summary: {
        totalpatients: "",
        compliance: "",
        alerts: "",
        completed: ""
      },
      currentformstatus:"new",
      showAddEproFormTemplate: false,
      showAddEproActivityTemplate: false,
      showpop: false,
      showpops: false,
      showpopup: false,
      showLoading:true,
      showRecentSubLoading:true,
      showEcrfLoading:true,
      showActiveLoading:true,
      status: {
        "Visit Ongoing": 'success',
        "Enrolled": 'info',
        "Pre-Screening": 'warning',
        "Screening": 'warning',
        "Follow-up": 'info',
        "Completed": 'success',
        "Withdrawn": 'danger',
        "Lost to Follow-up": 'danger',
        "Discontinued": 'danger',
        "New": 'danger'
      },
      formstatus: {
        "New": 'info',
        "Verified": 'success',
        "Unverified": 'warning',
        "Discontinued": 'danger',
      },
      questionnaires: [
        'Pain Scale (DAILY)',
        'Fatigue Assessment',
        'Quality of Life',
        'Medication Adherence',
        'Weekly Symptom Report'
      ],
      patientlist: [],
      Compliance: [],
      showpopups: false,
      // pateintlist: [],
      activeAlerts: [],
      alertId: "",
      baseurl: process.env.VUE_APP_Service_URL,
      defaultTime: "",
      defaultDate: "",
      ecrfformlist: [],
      scheduleList: [],
      showpoup: false,
      patientId: "",
      patientNo: "",
      setshowFormModal: false,
      showAlertStatusPopup: false,
      loadingSchedules: false,
      currentform: "",
      recentsubmissions: [],
      showAlertDetailsPopup: false,
      alertType: "",
      alertId: "",
      completedarray: [],
      querypopup : false,
      AlertId: "",
      Querydetails: [],
      showloader: false,  
      showContent: false,
      showQueryAlertPopup : false,
      queryid: "",
    };
  },
  methods: {
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
    toTime(data) {
      if (data) {
        return moment(data).format(this.defaultTime);
      }
    },
    relativeTime(data) {
      if (data) {
        return moment(data).fromNow();
      }
    },
    viewAlertDetails(id, type) {
      this.showAlertDetailsPopup = true;
      this.alertType = type;
      this.alertId = id;
    },
    openAlertStatusPopup(id) {
      this.showAlertStatusPopup = true;
      this.alertId = id;
    },
    closeAlertStatusPopup() {
      this.showAlertStatusPopup = false;
      if (this.showAlertDetailsPopup == true) {
        this.$refs.viewPopup?.getActiveAlerts()
      }
    },
    async openEproFormPopup(patientId) {
      this.showAddEproFormTemplate = true;
      this.patientId = patientId;
      this.getEPROFormsList()
    },
    closeAlertDetailsPopup() {
      this.showAlertDetailsPopup = false;
    },
    async openEproAcitivtyPopup(patientId) {
      this.showAddEproActivityTemplate = true;
      this.patientId = patientId;
      this.getEPROScheduleList()
    },
   
    async openEproPopupAlert() {
      this.showpoup = true;
      this.showActiveLoading=true
      this.activeAlerts = []
      this.showActiveAlertLoading = true
      try {
        const token = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/forms/alert/getaudits?StudyId=${store.getters.getStudyIs}&Active=true&Tag=ePRO`,
          { headers: { Authorization: "Bearer " + token } }
        );
        this.activeAlerts = response.data.entities;
        this.activeAlertsCount = response.data.totalCount;
    
        this.activeAlerts.forEach(alert => {
          console.log("Alert TemplateCategory:", alert.TemplateCategory);
        });
            } catch (error) {
        this.showActiveAlertLoading = false;
        console.error("Error fetching alerts:", error);
      }
    
    },
    async getActiveAlertsCounts() {   
      try {
        const token = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/forms/alert/getcounts?StudyId=${store.getters.getStudyIs}&Tag=ePRO`,
          { headers: { Authorization: "Bearer " + token } }
        );      
        console.log("alerts count is,", this.alertsCount);
        this.summary.alerts = response.data.FilterCount;
      } catch (error) {
        console.error("Error fetching alerts:", error);
      }
    },
    async openEproPopupCompliance() {
      this.showpop = true;
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      try {
        const response = await axios.get(
          `${this.baseurl}/management/epro/listcompliance?studyId=${stdid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.Compliance = response.data;
        // if (Array.isArray(this.pateintlist)) {
        //   this.pateintlist = this.pateintlist.map(patient => {
        //   const complianceObj = response.data.find(c => c.patientId === patient.patientId);
        //   return {
        //     ...patient,
        //     compliancePercentage: complianceObj ? complianceObj.compliancePercentage : 0,
        //     patientNo: complianceObj ? complianceObj.patientNo : patient.patientNo
        //   };
        //   });
        // }
        console.log("Compliance data:", response.data);
      } catch (error) {
        console.error("Error fetching compliance data:", error);
      }
    },
    returnClass(status) {
      const badgeClasses = {
        "Completed": "badge bg-success",
        "Unverified": "badge bg-warning",
        "Overdue": "badge bg-warning",
        "New": "badge bg-info",
        "Verified": "badge bg-success"
      };
      return badgeClasses[status] || "badge badge-default"; // Default class if status is unknown

    },
    CloseComplianceList() {
      this.showpop = false;

    },
    CloseAlertList() {
      this.showpoup = false;
    },
    
    closeEproModal() {
      this.showAddEproFormTemplate = false;

    },
    closeEproActivitytModal() {
      this.showAddEproActivityTemplate = false;
    },
    async showformmodel(currentform) {
      this.currentform = currentform;
      this.currentformstatus = "new";
      this.setshowFormModal = true;
    },
    async getEPROScheduleList() {
      this.scheduleList = []
      this.loadingSchedules = true
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/forms/epro/getsubjectschedules?studyid=${store.getters.getStudyIs}&subjectid=${this.patientId}&visitType=Subject Visit&SortProperty=visitDate&SortOrder=0`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data) {
            this.scheduleList = response.data.entities;
            this.loadingSchedules = false
          } else {
            this.loadingSchedules = false
            console.log("No ePRO forms found");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getEPROFormsList() {
      this.showEcrfLoading=true
      const idtoken = store.getters.getIdToken;
      const currentstudy = await store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/epro/ecrfformslist?studyId=${currentstudy}&category=ePRO`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data) {
            this.ecrfformlist = response.data.entities;
          } else {
            console.log("No ePRO forms found");
          }
          this.showEcrfLoading=false
        })
        .catch((err) => {
          this.showEcrfLoading=false
          console.log(err);
        });
    },
    async saveForm(forms) {
      const idtoken = store.getters.getIdToken;
      try {
        if ((forms.useDate && forms.useRecurrence) || (!forms.useDate && !forms.useRecurrence)) {
          alert("Please choose either 'Select Date' or 'Recurrence Cycle'.");
          return;
        }
        if (forms.useDate) {
          if (!forms.selectedDate) {
            alert("Please select a date.");
            return;
          }
        }
        if (forms.useRecurrence) {
          if (!forms.selectedRecurrence) {
            alert("Please select a recurrence cycle.");
            return;
          }
          if (!forms.recurrenceFromDate) {
            alert("Please select a from date.");
            return;
          }
          if (!forms.occurrence || forms.occurrence < 1) {
            alert("Please enter a valid occurrence (min 1).");
            return;
          }
        }
        this.referanceType = "";
        this.occuranceStartDate = "";
        this.totalOccurance = "";
        if (forms.useDate) {
          this.occuranceStartDate = forms.selectedDate;
          this.totalOccurance = 1;
          this.referanceType = "Daily";
        } else if (forms.useRecurrence) {
          this.referanceType = forms.selectedRecurrence;
          this.occuranceStartDate = forms.recurrenceFromDate;
          this.totalOccurance = forms.occurrence;
        }

        this.templateName = forms.templateName;
        this.templateId = forms.template_ID;

        const response = await axios.post(
          `${this.baseurl}/management/patientschedule/eprooccurrenceforms?SubjectId=${this.patientId}&ReferanceType=${this.referanceType}&OccuranceStartDate=${this.occuranceStartDate}&TotalOccurance=${this.totalOccurance}&TemplateName=${this.templateName}&TemplateId=${this.templateId}&visitType=Subject%20Visit`,
          {},
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        alert(this.$t("navigations.epro forms assigned successfully"));
        this.referanceType = "";
        this.occuranceStartDate = "";
        this.totalOccurance = "";
        this.templateName = "";
        this.templateId = "";
        if (forms.useDate) {
          forms.selectedDate = "";
          forms.useDate = false;
        }
        if (forms.useRecurrence) {
          forms.selectedRecurrence = "";
          forms.recurrenceFromDate = "";
          forms.occurrence = "";
          forms.useRecurrence = false;
        }
        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error calling ePRO occurrence forms API:", error);
      }
    },
    async closeformModal() {
      this.currentform = "";
      this.setshowFormModal = false;
    },
    async getpatientlist() {
      this.showLoading=true
      const idtoken = store.getters.getIdToken;
      const currentstudy = await store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/epro/listsubjects?studyId=${currentstudy}&status=${'Visit Ongoing'}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.patientlist = res.data.entities;
          this.summary.totalpatients = res.data.totalCount;
            this.showLoading=false
        })
        .catch((err) => {
            this.showLoading=false
          console.log(err);
        });
    },
    async openEproPopupSubjects() {
      this.showpopups = true;
      this.getpatientlist();
    },
    CloseSubjectList() {
      this.showpopups = false;
    },

    async GetRecentFormData() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/forms/forms/getpaginatedrecentforms?studyId=${stdid}&pageindex=0&pagesize=10000&SortProperty=&SortOrder=1&api-version=1.0`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((response) => {
          if (response.data) {
            this.recentformList = response.data.results
          }
          else {
            console.log("no forms found");
          }
        })

        .catch((err) => {
          console.log(err);
        });
    },
    async getecrfformlist() {
      this.showEcrfLoading=true
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/epro/ecrfformslist?studyId=${stdid}&category=ePRO`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((response) => {
          if (response.data) {
            this.ecrfformlist = response.data.entities
          }
          else {
            console.log("no forms found");
          }
          this.showEcrfLoading=false
        })

        .catch((err) => {
          this.showEcrfLoading=false
          console.log(err);
        });
    },
    async getcomplaince() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/epro/compliance?studyId=${stdid}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((response) => {
          if (response.data) {
            this.summary.compliance = response.data;
          }
          else {
            console.log("no forms found");
          }
        })

        .catch((err) => {
          console.log(err);
        });
    },
    CloseCompletedFormtList() {
      this.showpopup = false;
    },
    async openEproPopupCompletedForms() {
      this.showpopup = true;
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      try {
        const response = await axios.get(
          `${this.baseurl}/management/epro/listcompletedepro?studyId=${stdid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        // Ensure response.data is an array of completed forms
        this.completedarray = Array.isArray(response.data) ? response.data : [];
        // If you want to log just the form names:
        const formNames = this.completedarray.map(item => item.formsName);
        console.log("Completed ePRO form names:", formNames);
      } catch (error) {
        console.error("Error fetching completed ePRO forms:", error);
      }
    },

    // Add a method to get the form name by id (for use in your view/template)
    getCompletedFormName(formId) {
      const form = this.completedarray.find(item => item.formId === formId);
      return form ? form.formName : '';
    },
    async getcompleted() {

      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/epro/completedepro?studyId=${stdid}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((response) => {
          if (response.data) {
            this.summary.completed = response.data;
          }
          else {
            console.log("no forms found");
          }
        })

        .catch((err) => {
          console.log(err);
        });
    },
    async gotoform(formid) {
      // this.$router.push(`/showformwithdata/${formid}`);
      this.currentform = formid;
      this.currentformstatus = "Completed";
      this.setshowFormModal = true;
    },
    async getrecentsubmissions() {
      this.showRecentSubLoading=true
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/forms/epro/getformsforepro?studyid=${stdid}&VisitType=Subject Visit&isReview=true`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((response) => {
          if (response.data) {
            this.recentsubmissions = response.data;
          }
          else {
            console.log("no forms found");
          }
          this.showRecentSubLoading=false
        })

        .catch((err) => {
          this.showRecentSubLoading=false
          console.log(err);
        });
    },
    async getActiveAlerts() {
      this.activeAlerts = []
      this.showActiveAlertLoading = true
      this.showActiveLoading=true
      try {
        const token = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/forms/alert/getaudits?StudyId=${store.getters.getStudyIs}&Tag=ePRO&Active=true`,
          { headers: { Authorization: "Bearer " + token } }
        );
        this.activeAlerts = response.data.entities;
        this.showActiveAlertLoading = false
        this.showActiveLoading=false
      } catch (error) {
        this.showActiveAlertLoading = false
        this.showActiveLoading=false
        console.error("Error fetching alerts:", error);
      }
    },
    getSubjectIdByPatientId(id) {
      const match = this.patientlist.find(item => item.patientId === id);
      return match ? match.subjectId : undefined;
    },
    Openquerypopup(id) {
            this.querypopup = true;
            this.AlertId = id;
            this.openqueryapi(id);
    },
    async openqueryapi(id) {
            this.Querydetails = [];
            this.showloader = true;
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseurl}/forms/query/querylist?StudyId=${store.getters.getStudyIs}&QueryFor_Id=${id}&SortProperty=QueryOpenStatus&SortOrder=1`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.Querydetails = Array.isArray(response.data.results) ? response.data.results : [];
                if (this.Querydetails.length === 0) {
                    this.showContent = false;
                }
                else if (this.Querydetails.length > 0) {
                    this.showContent = true;
                }
                this.showloader = false;
                console.log("Query details:", this.Querydetails);
            } catch (error) {
                this.Querydetails = [];
                this.showContent = false;
                this.showloader = false;
                console.error("Error fetching query details:", error);

            }
    },
    viewforms(id) {
            this.showQueryAlertPopup = true;
            this.queryid = id;
    },
    Closequerypopup() {
            this.querypopup = false;
            this.querylistpopup = true;
            console.log("Closed query popup", this.alertId);
    },
    applychanges() {
      this.$refs.viewPopup?.querycount()
      this.openqueryapi(this.alertId);
    },
  },
};
